import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-clientes-entidad',
  templateUrl: './list-clientes-entidad.component.html',
  styleUrls: ['./list-clientes-entidad.component.scss']
})
export class ListClientesEntidadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
